import { motion } from "framer-motion";
import { TrendingUp, TrendingDown, Wallet, ListChecks } from "lucide-react";
import { fmt } from "@/lib/api";

const Card = ({ label, value, sub, icon: Icon, tone, testid, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay }}
    data-testid={testid}
    className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md hover:-translate-y-[1px] transition-all duration-200"
  >
    <div className="flex items-center justify-between">
      <span className="text-xs tracking-[0.2em] uppercase font-semibold text-gray-500">{label}</span>
      <Icon className={`h-5 w-5 ${tone}`} />
    </div>
    <div className={`font-mono tracking-tight text-3xl font-semibold mt-4 ${tone}`}>{value}</div>
    {sub && <div className="text-sm text-gray-500 mt-1">{sub}</div>}
  </motion.div>
);

export const KpiCards = ({ pnl }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      <Card
        label="Total Income"
        value={fmt(pnl.total_income)}
        icon={TrendingUp}
        tone="text-emerald-600"
        testid="kpi-total-income"
        delay={0}
      />
      <Card
        label="Total Expenses"
        value={fmt(pnl.total_expense)}
        icon={TrendingDown}
        tone="text-rose-600"
        testid="kpi-total-expense"
        delay={0.05}
      />
      <Card
        label="Net Profit"
        value={fmt(pnl.net_profit)}
        icon={Wallet}
        tone={pnl.net_profit >= 0 ? "text-gray-900" : "text-rose-600"}
        testid="kpi-net-profit"
        delay={0.1}
      />
      <Card
        label="Transactions"
        value={pnl.count}
        icon={ListChecks}
        tone="text-gray-900"
        testid="kpi-count"
        delay={0.15}
      />
    </div>
  );
};
